import * as React from 'react';
import styles from './index.less';
import * as ReactDOM from 'react-dom/client';
import FObjectSelectorDrawer from './FObjectSelectorDrawer';

interface fObjectSelectorDrawerProps {
  resourceTypeCode: string;
}

type ReturnData = {
  bucketID: string;
  bucketName: string;
  objID: string;
  objName: string;
  sha1: string;
} | null;

function fObjectSelectorDrawer({
  resourceTypeCode,
}: fObjectSelectorDrawerProps): Promise<ReturnData> {
  return new Promise<ReturnData>((resolve) => {
    const divRoot = self.document.body;
    const div = self.document.createElement('div') as HTMLDivElement;
    divRoot.appendChild(div);
    const root = ReactDOM.createRoot(div);
    return root.render(
      <FObjectSelectorDrawer
        resourceTypeCode={resourceTypeCode}
        onSelect={(obj) => {
          resolve(obj);
        }}
        onClose={() => {
          resolve(null);
          setTimeout(() => {
            root.unmount();
            div.remove();
          }, 300);
        }}
      />,
    );
  });
}

export default fObjectSelectorDrawer;
